import { render, staticRenderFns } from "./DialogSvg.vue?vue&type=template&id=31aface8&scoped=true"
import script from "./DialogSvg.vue?vue&type=script&lang=js"
export * from "./DialogSvg.vue?vue&type=script&lang=js"
import style0 from "./DialogSvg.vue?vue&type=style&index=0&id=31aface8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aface8",
  null
  
)

export default component.exports